import React, { useState } from "react";
import axios from "axios";
import CurrentTemp from "./CurrentTemp";
import Forecast from "./Forecast";
import './App.css';

export default function WeatherApp(props){
    const [ready, setReady] = useState(false);
    const [weatherData, setWeatherData] = useState({});
    const [city, setCity] = useState(props.defaultCity);

 function handleResponse(response){
         setReady(true);
         setWeatherData({
            city: response.data.city,
            description: response.data.condition.description,
            icon: response.data.condition.icon_url,
            temperature: Math.round(response.data.temperature.current),
            humidity: response.data.temperature.humidity,
            wind: Math.round(response.data.wind.speed),
            time: new Date(response.data.time *1000),
            coordinates: response.data.coordinates,
         });
 }
    function search(){
        const apiKey = "3accb3e0a43t5204of065d23ba7a9b14";
        const apiURL = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}`;
    
        axios.get(apiURL).then(handleResponse);
    }

    function handleSubmit(event){
        event.preventDefault();
        search();
    }

    function handleCityChange(event){
        setCity(event.target.value);
    }

 if(ready){
        return(
        <div className="container">
            <form onSubmit={handleSubmit}>
        <div className="row">
            <div className="col-9">
            <input className="search" type="search" placeholder="type a city..." onChange={handleCityChange}></input>
            </div>
            <div className="col-3">
            <input className="btn-submit" type="submit" value="search"></input>
            </div>
        </div>
    </form>
            <CurrentTemp  data={weatherData}/>  
            <Forecast coordinates={weatherData.coordinates}/>
        </div>)
 } else{
    search();
    return "Loading...";
 }


   
}